/* eslint eqeqeq: "off" */
import React, { useContext, useEffect, useState, useRef } from 'react';
import Context from '../pages/Context';
// imagens.
import power from '../images/power.png';
import SimplePeer from 'simple-peer';
// websocket (socket.io)
import { io } from 'socket.io-client';
import toast from '../functions/toast';
function Teleconsulta() {

  const {
    teleconsulta, setteleconsulta,
    pacientes,
    // cliente,
    objatendimento,
    setsocket_teleconsulta,
    socket_teleconsulta,
    settoast,
  } = useContext(Context);

  const [objstream, setobjstream] = useState();
  const [codigo, setcodigo] = useState(null);

  function getRandomArbitrary(min, max) {
    setcodigo(objatendimento.id_atendimento);
  }

  let peer_medico = null;
  const peerRef = useRef(null);
  // const [peer_medico, setpeer_medico] = useState(null);

  useEffect(() => {
    if (teleconsulta == 1) {
      getRandomArbitrary(10000, 20000);
      // setsocket_teleconsulta(io.connect('http://localhost:4000'));
      setsocket_teleconsulta(io.connect('https://pulsar-pep-teleconsultas-server.up.railway.app'));
    }

    // eslint-disable-next-line
  }, [teleconsulta]);

  const startPeerMedico = () => {
    setTimeout(() => {
      let constraints =
      {
        video: {
          facingMode: 'environment'
        },
        audio: true
      }
      navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
        // projetando a câmera do médico na tela do médico.
        setobjstream(stream);
        let video_medico = document.getElementById('video-teleconsulta-medico');
        video_medico.srcObject = stream;

        // criando o peer_medico.
        peer_medico = new SimplePeer({
          initiator: true,
          trickle: false,
          stream: stream,
          config: {
            iceServers: [
              { urls: "stun:stun.l.google.com:19302" }
            ]
          }
        });

        // criando useRef para guardar o objeto peer.
        peerRef.current = peer_medico;

        // ## TROCA DE SINAIS DOS PARES PARA ESTABELECER CONEXÃO ## //
        // enviando sinal do médico para o server.
        peer_medico.on('signal', function (data) { // peer.on('signal', function()) >> este peer está entregando seu sinal para ser disponibilizado para outro peer, via socket.io.
          console.log(data.type);
          console.log('ENVIANDO SINAL DO MÉDICO PARA O SERVER.');
          let obj = {
            tipo: 'medico',
            codigo: objatendimento.id_atendimento,
            data: data,
            id: socket_teleconsulta.id,
          }
          console.log(obj);
          socket_teleconsulta.emit('upload dados peer-medico', obj);
        });

        // recebendo do server o sinal do paciente.
        socket_teleconsulta.on('dados peer-paciente', function (data) {
          console.log('RECEBENDO DO SERVER O SINAL DO PACIENTE.');
          peer_medico.signal(data); // peer.signal(data) >> este peer está pegando um sinal de outro peer.
          console.log(data);
        });

        // projetando a câmera do paciente na tela do paciente.
        peer_medico.on('stream', function (stream) {
          var video = document.getElementById('video-teleconsulta-paciente');
          video.srcObject = stream;
          video.play();
        });
      }).catch(() => {
        toast(settoast, 'CÂMERA INDISPONÍVEL PARA A TELECONSULTA', 'red', 3000);
        setteleconsulta(0);
      });
    }, 2000);
  }

  const encerrandoStream = () => {
    let stream = objstream;
    console.log(stream);
    stream.getTracks().forEach(function (track) {
      track.stop();
      console.log('ENCERRANDO STREAM');
    });
  }

  const [newelementposition, setnewelementposition] = useState({ x: 0, y: 0 });
  const handleMouseDown = (e) => {
    let element = document.getElementById('drag-teleconsulta');
    localStorage.setItem('firstmouseposition', JSON.stringify({ x: e.clientX, y: e.clientY }));
    localStorage.setItem('firstelementposition', JSON.stringify({ x: parseInt(element.style.left), y: parseInt(element.style.top) }))
    // setfirstelementposition({ x: parseInt(element.style.left), y: parseInt(element.style.top) });

    // Add global event listeners for mousemove and mouseup
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (e) => {
    console.log('MOUSE MOVENDO');
    let newmouseposition = { x: e.clientX, y: e.clientY };
    let firstelementposition = JSON.parse(localStorage.getItem('firstelementposition'));
    let firstmouseposition = JSON.parse(localStorage.getItem('firstmouseposition'));
    // setnewmouseposition({ x: e.clientX, y: e.clientY });
    console.log('POSIÇÕES ANTIGAS DO MOUSE:');
    console.log(firstmouseposition);
    console.log('POSIÇÕES ATUAIS DO MOUSE:');
    console.log(newmouseposition);
    let change = { x: newmouseposition.x - firstmouseposition.x, y: newmouseposition.y - firstmouseposition.y }
    setnewelementposition({ x: firstelementposition.x + change.x, y: firstelementposition.y + change.y });
  };

  const handleMouseUp = () => {
    console.log('MOUSE LIBERADO');
    // Remove global event listeners
    window.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('mouseup', handleMouseUp);
  };

  function geraWhatsapp() {
    let atendimento = objatendimento;
    let paciente = pacientes.filter(item => item.id_paciente == atendimento.id_paciente).pop();

    const gzappy_url_envia_mensagem = "https://v2-api.gzappy.com/message/send-text";
    const instance_id = 'L05K3GC2YX03DGWYLDKZQW5L';
    const instance_token = '2d763c00-4b6d-4842-99d7-cb32ea357a80';
    const GZAPPY_API_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwdWJsaWNfaW5zdGFuY2VfaWQiOiJMNEZYQyoqKioqKioqKioqKioqQkRJU0kiLCJleHBpcmVzX2F0IjoiMjAyNi0wNC0yN1QxMjoyNDoyNS4xMjlaIiwiaWF0IjoxNzQ1NzU2NjY1LCJleHAiOjIzNTA1NTY2NjV9.9cDAdZQbNyLV0U6EAMgfgCcRFcPREOIccDyDfI0EtlI';

    const message =
      'Olá, ' + atendimento.nome_paciente + '!\n' +
      "Você tem uma consulta online agora. Acesse o link 'https://www.pulsarpep.com ' e insira o código ' + codigo + ' para iniciar seu atendimento."
    const rawphone = paciente.telefone;

    let cleanphone = rawphone.replace("(", "");
    cleanphone = cleanphone.replace(")", "");
    cleanphone = cleanphone.replace("-", "");
    cleanphone = cleanphone.replace(" ", "");
    cleanphone = "55" + cleanphone;

    fetch(gzappy_url_envia_mensagem, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // 'user_token_id': USER_TOKEN_ID,
        'Authorization': `Bearer ${GZAPPY_API_TOKEN}`
      },
      body: JSON.stringify({
        instance_id: instance_id,
        instance_token: instance_token,
        message: [message],
        phone: [cleanphone]
      })
    })
    toast(settoast, 'CÓDIGO ENVIADO COM SUCESSO.', '#52be80', 3000);
  }

  const [btnpower, setbtnpower] = useState(0);
  const [btntexto, setbtntexto] = useState('INICIAR TELECONSULTA');
  return (
    <div className="janela cor1opaque" id="drag-teleconsulta"
      style={{
        display: teleconsulta == 1 ? 'flex' : 'none',
        position: 'fixed', zIndex: 200,
        margin: 5, padding: 10,
        left: newelementposition.x, top: newelementposition.y
      }}
      onMouseDown={(e) => {
        handleMouseDown(e);
      }}
    >
      <div style={{
        display: 'flex',
        flexDirection: 'column', justifyContent: 'center'
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ position: 'relative', displa: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <div className='text2' style={{ width: 200 }}>{objatendimento != undefined || objatendimento != null || objatendimento != [] ? objatendimento.nome_paciente : 'PACIENTE'}</div>
              <video id="video-teleconsulta-paciente" autoplay='true' disablePictureInPicture='true' width='300px' playsInline
                style={{ objectFit: 'contain', borderRadius: 5, width: 300, backgroundColor: 'transparent' }}>
              </video>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', position: 'absolute', bottom: 5, right: 5 }}>
              <video id="video-teleconsulta-medico" autoplay='true' disablePictureInPicture='true' width='100px'
                style={{ objectFit: 'contain', borderRadius: 5, width: 100, backgroundColor: 'transparent' }}>
              </video>
            </div>
          </div>
        </div>
      </div>
      <div className="text2" style={{ fontSize: 20 }}>
        {codigo}
      </div>
      <div className='button green' onClick={() => geraWhatsapp()} style={{ paddingLeft: 20, paddingRight: 20 }}>
        ENVIAR TICKET PARA O PACIENTE
      </div>
      <div
        style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div id="botão para iniciar ou encerrar teleconsulta"
          className={btnpower == 0 ? "button-green" : "button-red"}
          style={{
            width: 200,
            alignSelf: 'center',
          }}
          onClick={() => {
            if (btnpower == 0) {
              setbtnpower(1);
              setbtntexto('ENCERRAR TELECONSULTA');
              startPeerMedico();
            } else {
              setbtnpower(0);
              setbtntexto('INICIAR TELECONSULTA');
              socket_teleconsulta.emit('desconectar', objatendimento.id_atendimento);
              encerrandoStream();
              setteleconsulta(0);
              if (peerRef.current) {
                console.log(peerRef.current);
                peerRef.current.destroy();
              }
              socket_teleconsulta.disconnect(); // única função eficaz para desconexão do usuário a partir do cliente.
            }
          }}>
          <img
            alt=""
            src={power}
            style={{ width: 30, height: 30 }}
          ></img>
          <div style={{ marginLeft: 5 }}>{btntexto}</div>
        </div>
      </div>
      <div className='button red'
        style={{ display: btnpower == 0 ? 'flex' : 'none', width: 200, marginTop: 0, marginBottom: 15 }}
        onClick={() => setteleconsulta(0)}
      >
        FECHAR
      </div>
    </div >
  )
}

export default Teleconsulta;